import { useMemo } from 'react'
import type { ContactsFeatureFlags } from 'contacts/Contacts'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

export const useContactsMfeFeatureFlags = (): ContactsFeatureFlags => {
  const {
    enableHybridAddress,
    enableUsLaunchRestrictions,
    enableUsRestrictedCurrencies,
    enableMaltaAccounts,
    enableGovernmentIds,
  } = useFeatureFlags()
  const disallowPaymentCurrencies = enableMaltaAccounts?.disallowPaymentCurrencies
  const { accountCapabilities } = useAccountsContext() || {}
  const {
    isLatamBankAccountCapabilityEnabled,
    isUsdCRNowBeneficiaryCapabilityEnabled,
    isUsdFedNowBeneficiaryCapabilityEnabled,
    isUsdRtpBeneficiaryCapabilityEnabled,
    enabledLocalBankingCurrencies,
  } = accountCapabilities || {}

  return useMemo(
    () => ({
      enableHybridAddress,
      enableUsLaunchRestrictions,
      enableUsRestrictedCurrencies,
      disallowPaymentCurrencies,
      isLatamBankAccountCapabilityEnabled,
      enabledLocalBankingCurrencies,
      isUsdCRNowBeneficiaryCapabilityEnabled,
      isUsdFedNowBeneficiaryCapabilityEnabled,
      isUsdRtpBeneficiaryCapabilityEnabled,
      enableGovernmentIds,
    }),
    [
      enableHybridAddress,
      enableUsLaunchRestrictions,
      enableUsRestrictedCurrencies,
      disallowPaymentCurrencies,
      isLatamBankAccountCapabilityEnabled,
      enabledLocalBankingCurrencies,
      isUsdCRNowBeneficiaryCapabilityEnabled,
      isUsdFedNowBeneficiaryCapabilityEnabled,
      isUsdRtpBeneficiaryCapabilityEnabled,
      enableGovernmentIds,
    ]
  )
}
